/* =============================================
   Elevare Theme JS
   ============================================= */

document.addEventListener('DOMContentLoaded', function () {

  /* --- Exit-intent popup (WELKOM10): max 1x per sessie (sessionStorage), pas actief na
     4s op de pagina (voorkomt een instant-trigger bij het laden zelf). Desktop: muis
     verlaat de viewport aan de bovenkant (richting tabbladen/adresbalk = klassiek
     exit-signaal). Mobiel heeft geen betrouwbaar "muis verlaat scherm"-signaal, dus daar
     een tijd-gebaseerde benadering: getoond na 25s als de bezoeker nog niet heeft
     afgerekend/de popup niet al zag. */
  (function () {
    var popup = document.getElementById('ExitPopup');
    if (!popup) return;
    if (sessionStorage.getItem('exitPopupShown')) return;

    var armed = false;
    setTimeout(function () { armed = true; }, 4000);

    function show() {
      if (!armed || sessionStorage.getItem('exitPopupShown')) return;
      popup.classList.add('exit-popup--visible');
      sessionStorage.setItem('exitPopupShown', '1');
    }
    function hide() {
      popup.classList.remove('exit-popup--visible');
    }

    document.addEventListener('mouseleave', function (e) {
      if (e.clientY <= 0) show();
    });

    var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    if (isTouch) {
      setTimeout(show, 25000);
    }

    var closeBtn = document.getElementById('ExitPopupClose');
    var backdrop = document.getElementById('ExitPopupBackdrop');
    if (closeBtn) closeBtn.addEventListener('click', hide);
    if (backdrop) backdrop.addEventListener('click', hide);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hide();
    });
  })();

  /* --- Roterende aankondigingsbalk --- */
  var topbarMsgs = document.querySelectorAll('.topbar__msg');
  if (topbarMsgs.length > 1) {
    var topbarCurrent = 0;
    topbarMsgs[0].classList.add('topbar__msg--active');
    setInterval(function () {
      topbarMsgs[topbarCurrent].classList.remove('topbar__msg--active');
      topbarMsgs[topbarCurrent].classList.add('topbar__msg--exit');
      var prev = topbarCurrent;
      topbarCurrent = (topbarCurrent + 1) % topbarMsgs.length;
      topbarMsgs[topbarCurrent].classList.add('topbar__msg--active');
      setTimeout(function () { topbarMsgs[prev].classList.remove('topbar__msg--exit'); }, 450);
    }, 3500);
  }

  /* --- Sticky add-to-cart: altijd zichtbaar vanaf page-load (class staat al in de HTML,
     zie main-product.liquid). Geen scroll-afhankelijke show/hide meer nodig - dat is 18 aug
     2x geprobeerd (IntersectionObserver op de hoofdknop, daarna een scroll-drempel) en beide
     keren teruggedraaid: Damien wil de balk meteen zien, niet pas na scrollen. Hier blijft
     alleen de klik-doorschakeling naar de echte (verborgen) hoofdknop staan. */
  var mainAtcBtn = document.querySelector('.btn-addtocart');
  var stickyBtn  = document.getElementById('StickyAtcBtn');
  if (mainAtcBtn && stickyBtn) {
    stickyBtn.addEventListener('click', function () { mainAtcBtn.click(); });
  }

  /* --- Sticky header: schaduw + écht vastgeplakt blijven bij scrollen (11 aug) ---
     position:sticky alleen werkte niet omdat de Shopify-sectiewrapper rond de header precies
     zo hoog is als de header zelf (sticky's "containing block" loopt dan meteen vol). Daarom
     hier een class-toggle naar position:fixed, met een compenserende body-padding zodat de
     pagina-inhoud niet omhoog springt op het moment dat de header uit de normale flow gaat. */
  var siteHeader = document.getElementById('SiteHeader');
  var topbarEl = document.querySelector('.topbar');
  if (siteHeader) {
    var topbarHeight = topbarEl ? topbarEl.offsetHeight : 0;
    var headerHeight = siteHeader.offsetHeight;
    var headerPinned = false;

    function updateHeaderPin() {
      var shouldPin = window.scrollY > topbarHeight;
      if (shouldPin !== headerPinned) {
        headerPinned = shouldPin;
        siteHeader.classList.toggle('site-header--pinned', headerPinned);
        document.body.style.paddingTop = headerPinned ? headerHeight + 'px' : '';
      }
    }

    window.addEventListener('scroll', function () {
      siteHeader.classList.toggle('scrolled', window.scrollY > 10);
      updateHeaderPin();
    }, { passive: true });

    window.addEventListener('resize', function () {
      topbarHeight = topbarEl ? topbarEl.offsetHeight : 0;
      if (!headerPinned) headerHeight = siteHeader.offsetHeight;
    });
  }

  /* --- FAQ toggle --- */
  document.querySelectorAll('[data-faq-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item    = btn.closest('.faq-item');
      var content = item.querySelector('[data-faq-content]');
      var icon    = item.querySelector('.faq-icon');
      var open    = item.getAttribute('data-open') === 'true';
      item.setAttribute('data-open', (!open).toString());
      content.style.display = open ? 'none' : 'block';
      if (icon) icon.textContent = open ? '+' : '×';
    });
  });

  /* --- Mobiel menu --- */
  var hamburger  = document.getElementById('HamburgerBtn');
  var mobileNav  = document.getElementById('MobileNav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('mobile-nav--open');
      hamburger.setAttribute('aria-expanded', isOpen.toString());
      document.body.classList.toggle('nav-open', isOpen);
    });
  }

  /* --- Winkelwagen drawer --- */
  var drawerTrigger = document.getElementById('CartDrawerTrigger');
  var drawer        = document.getElementById('CartDrawer');
  var overlay       = document.getElementById('CartOverlay');
  var drawerClose   = document.getElementById('CartDrawerClose');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('cart-overlay--visible');
    document.body.classList.add('drawer-open');
    updateCartDrawer();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('cart-overlay--visible');
    document.body.classList.remove('drawer-open');
  }

  if (drawerTrigger) drawerTrigger.addEventListener('click', openDrawer);
  if (drawerClose)   drawerClose.addEventListener('click', closeDrawer);
  if (overlay)       overlay.addEventListener('click', closeDrawer);

  /* --- Reviews slider --- */
  var reviews     = document.querySelectorAll('.review');
  var dots        = document.querySelectorAll('.dot');
  var currentReview = 0;
  if (reviews.length > 1) {
    function showReview(idx) {
      reviews.forEach(function (r) { r.classList.remove('review--active'); });
      dots.forEach(function (d) { d.classList.remove('dot--active'); });
      reviews[idx].classList.add('review--active');
      if (dots[idx]) dots[idx].classList.add('dot--active');
      currentReview = idx;
    }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        showReview(parseInt(this.getAttribute('data-index')));
      });
    });
    setInterval(function () {
      showReview((currentReview + 1) % reviews.length);
    }, 4500);
  }

  /* --- Eerste laden winkelwagen badge --- */
  refreshCartBadge();
});

/* =============================================
   Winkelwagen drawer inhoud laden
   ============================================= */
function updateCartDrawer() {
  var body    = document.getElementById('CartDrawerBody');
  var footer  = document.getElementById('CartDrawerFooter');
  var subtotal = document.getElementById('CartSubtotal');
  if (!body) return;

  fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {

      /* badge bijwerken */
      refreshCartBadge(cart.item_count);

      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-drawer__empty">Je winkelwagen is leeg.<br><a href="/collections/all" class="btn" style="margin-top:18px;display:inline-flex">Shop nu</a></div>';
        if (footer) footer.style.display = 'none';
        return;
      }

      /* Subtotaal */
      if (footer)  footer.style.display = 'block';
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

      /* Voortgangsbalk gratis verzending */
      var threshold = 5000; /* €50 in centen */
      var remaining = Math.max(0, threshold - cart.total_price);
      var pct       = Math.min(100, (cart.total_price / threshold) * 100);
      var shippingBar = remaining > 0
        ? '<div class="shipping-bar"><div class="shipping-bar__fill" style="width:' + pct + '%"></div></div><p class="small muted" style="margin:4px 0 14px">Nog <strong>' + formatMoney(remaining) + '</strong> voor gratis verzending</p>'
        : '<p class="small" style="color:#2e7d32;font-weight:600;margin:0 0 14px">🎉 Je hebt gratis verzending!</p>';

      /* Items */
      var html = shippingBar + '<ul class="cart-items">';
      cart.items.forEach(function (item) {
        html += '<li class="cart-item">';
        if (item.image) {
          html += '<img src="' + item.image + '" alt="' + escHtml(item.title) + '" class="cart-item__img">';
        }
        html += '<div class="cart-item__info">';
        html += '<p class="cart-item__title">' + escHtml(item.product_title) + '</p>';
        if (item.variant_title && item.variant_title !== 'Default Title') {
          html += '<p class="small muted" style="margin:2px 0">' + escHtml(item.variant_title) + '</p>';
        }
        html += '<div class="cart-item__controls">';
        html += '<button class="qty-btn" onclick="changeQty(\'' + item.key + '\', ' + (item.quantity - 1) + ')">−</button>';
        html += '<span class="qty-val">' + item.quantity + '</span>';
        html += '<button class="qty-btn" onclick="changeQty(\'' + item.key + '\', ' + (item.quantity + 1) + ')">+</button>';
        html += '<button class="remove-btn" onclick="changeQty(\'' + item.key + '\', 0)">🗑</button>';
        html += '</div></div>';
        html += '<strong class="cart-item__price">' + formatMoney(item.line_price) + '</strong>';
        html += '</li>';
      });
      html += '</ul>';
      body.innerHTML = html;
    })
    .catch(function () {
      if (body) body.innerHTML = '<p class="muted small">Kon winkelwagen niet laden.</p>';
    });
}

function changeQty(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(function () { updateCartDrawer(); });
}

function refreshCartBadge(count) {
  var badge = document.getElementById('CartBadge');
  if (!badge) return;
  if (count !== undefined) {
    badge.textContent = count;
    badge.classList.toggle('cart-badge--hidden', count === 0);
    return;
  }
  fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      badge.textContent = cart.item_count;
      badge.classList.toggle('cart-badge--hidden', cart.item_count === 0);
    });
}

function formatMoney(cents) {
  return '€' + (cents / 100).toFixed(2).replace('.', ',');
}

function copyExitCode() {
  var code = document.getElementById('ExitPopupCode');
  if (!code) return;
  navigator.clipboard.writeText(code.textContent.trim()).then(function () {
    document.getElementById('ExitPopup').classList.add('exit-popup--copied');
    setTimeout(function () {
      document.getElementById('ExitPopup').classList.remove('exit-popup--copied');
    }, 2500);
  });
}

function escHtml(str) {
  return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}
